import { render, staticRenderFns } from "./VDocumentation.vue?vue&type=template&id=8b9248e8&"
import script from "./VDocumentation.vue?vue&type=script&lang=js&"
export * from "./VDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./VDocumentation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports